<template>
  <div>
    <a-modal v-model="visible" width="620px" :mask-closable="false" title="添加测试套件" ok-text="保存并执行" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :keyboard="false" :model="modalForm" :rules="rules" :label-col="labelCol">
        <a-form-model-item label="类型" prop="suitType" :wrapper-col="wrapperCol">
          <a-select v-model="modalForm.suitType" show-search placeholder="任务类型" :filter-option="utils.filterOption" @change="onChangeTestSuit">
            <a-select-option v-for="suit in suitType" :key="suit.value" :value="suit.value" :disabled="suit.disabled">
              {{ suit.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="任务列表" prop="taskId" :wrapper-col="wrapperCol">
          <a-select v-model="modalForm.taskId" show-search :disabled="modalForm.suitType === null" placeholder="请选择任务" :filter-option="utils.filterOption" @change="changeTaskName">
            <a-select-option v-for="item in taskList" :key="item.id" :value="item.id" :disabled="item.bound">{{ "【"+item.id+"】"+item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="执行环境" prop="env" :wrapper-col="wrapperCol">
          <a-select v-model="modalForm.env" show-search :filter-option="utils.filterOption">
            <a-select-option v-for="item in nvwaEnvs" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <workflow-test-plan-modal :project-id="projectId" :workflow-id="workflowId" :step-id="currentStepId" :is-show="testPlanVisible" @test-plan-change="testPlanChange" @close="closeTestPlanModal" />
  </div>
</template>

<script>
import { queryConfigKeys } from '@/api/project/workflow';
import { suitType, nvwaEnvs } from '@/utils/dictionary';
import { getTestSuit } from '@/api/project/testPlan';
import { applicationVersions } from '@/api/tools/application';
import { serviceArtifactVersion } from '@/api/project/workflow';
import { automationTrigger } from '@/api/project/workflow';
import WorkflowTestPlanModal from '@/pages/project/workflow/components/WorkflowTestPlanModal';
import { workflowTestPlans, unBindWorkflowTestPlan } from '@/api/project/workflow';
export default {
  components: {
    WorkflowTestPlanModal
  },
  props: {
    tag: {
      type: String,
      default: 'qa_verfiy'
    },
    isShow: {
      type: Boolean,
      default: false
    },
    currentStepId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      testPlanVisible: false,
      suitType,
      nvwaEnvs,
      taskNmae: '',
      versionLoading: false,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      artifactVersionData: [],
      taskList: [],
      versionData: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      workflowId: parseInt(this.$route.query.workflowId) || null,
      modalForm: {
        suitType: null,
        taskId: null,
        env: null
      },
      filterForm: {
        service_id: null,
        artifact_id: null,
        version: null,
        page_number: 1,
        page_size: null
      },
      configData: [],
      rules: {
        service_id: [{ required: true, message: '服务不能为空', trigger: 'blur' }],
        image: [{ required: true, message: '制品版本不能为空', trigger: 'blur' }],
        developers: [{ required: true, message: '开发人员不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    /**
     * 监听模态框打开关闭
     */
    isShow() {
      this.visible = this.isShow;
      this.modalForm = {
        suitType: null,
        taskId: null,
        env: null
      };
    }
  },

  methods: {
    /**
     * 关闭模态框事件
     */
    close() {
      this.$refs.modalForm.resetFields();
      this.visible = false;
      this.$emit('close');
    },

    /**
     * 服务变化时的回调
     * @param {*} value
     * @param {*} option
     */
    onChangeTestSuit(key) {
      if (key === 3 || key === 4) {
        getTestSuit({ suit_id: key }).then(res => {
          this.taskList = res.data.items;
        });
      } else if (key === 2) {
        this.testPlanVisible = true;
      }
    },
    changeTaskName(value) {
      for (let i = 0; i < this.taskList.length; i++) {
        if (this.taskList[i].id === value) {
          this.taskName = this.taskList[i].name;
        }
      }
    },
    deletePlan(record) {
      // this.testPlans.splice(index, 1);
      unBindWorkflowTestPlan({
        project_id: this.projectId,
        workflow_id: this.workflowId,
        plan_id: record.id
      }).then(() => {
        this.$message.success('移除测试计划成功');
        this.getTestPlans();
      });
    },
    testPlanChange(rows) {
      const testPlanIds = this.testPlans.map(plan => plan.id);
      rows.forEach(row => {
        if (!testPlanIds.includes(row.id)) {
          this.testPlans.push(row);
        }
      });
      this.testPlanVisible = false;
      this.visible = false;
    },
    closeTestPlanModal() {
      this.testPlanVisible = false;
      this.visible = false;
      this.getTestPlans();
    },
    getTestPlans() {
      workflowTestPlans({
        project_id: this.projectId,
        workflow_id: this.workflowId,
        step_id: this.currentStepId
      }).then(res => {
        this.testPlans = res.data.items;
        this.devTestPlans = this.testPlans.filter(p => p.step === 38);
      });
    },
    /**
     * 获取制品版本列表
     */
    getArtifactVersionList() {
      this.versionLoading = true;
      this.artifactVersionData = [];
      serviceArtifactVersion({ service_id: this.filterForm.service_id, release_id: this.releaseId, workflow_id: this.workflowId }).then(res => {
        this.artifactVersionData = res.data.items;
        this.versionLoading = false;
      });
    },

    /**
     * 获取APP版本列表
     * @param {*} value 版本号搜索value
     */
    getAppliactionVersions(value = null) {
      applicationVersions({ service_id: this.filterForm.service_id, build_version: value }).then(res => {
        this.versionData = res.data.items;
      });
    },

    /**
     * 点击提交
     */
    submit() {
      automationTrigger({
        type: this.modalForm.suitType,
        workflow_id: this.workflowId,
        task_id: this.modalForm.taskId,
        env: this.modalForm.env,
        tag: this.tag,
        task_name: this.taskName,
        packge: ''
      }).then(() => {
        this.$message.success('触发自动化成功');
        this.visible = false;
      });
    },

    /**
     * 获取服务配置Keys列表
     */
    getConfigKeys() {
      this.configData = [];
      queryConfigKeys({ service_id: this.modalForm.service_id }).then(res => {
        this.configData = res.data.items;
      });
    }
  }
};
</script>
